module.exports = __webpack_public_path__ + "img/pyramid-table.fe904bf5.png";